<template>
  <div class="coins-list">
    <CoinsBundle v-for="item in props.coins" :key="item.id" :item="item"></CoinsBundle>
  </div>
</template>

<style scoped>
.coins-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: var(--margin-normal);
  margin-right: var(--margin-normal);
  gap: var(--margin-xs);
}
</style>

<script lang="ts" setup>
import StoreItemDTO from "@/models/StoreItemDTO";
import CoinsBundle from "@/components/store/CoinsBundle.vue";

const props = defineProps<{
  coins: StoreItemDTO[]
}>()

</script>